import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudflareService } from '../../service';

export type ListMembersConfig = typeof ListMembersConfig._.Config;

export const ListMembersConfig = IntegrationConfig.make({
  service: CloudflareService,
  name: Integration_Handler_Names_Enum.ListMembers,
  configSchema: z.object({
    accountId: z.string().min(1),
    emailPatternFilter: patternFilterSchema.optional(),
  }),
});
